import { fetchAuthSession } from './amplify'

export const getJwtString = async () => {
  const session = await fetchAuthSession()

  return session.tokens?.idToken?.toString()
}
